import React, { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { dbDiscounts } from "../../assets/testingData";

export default function Banner() {
  const [showBanner, setShowBanner] = useState(true);
  const [bannerText, setBannerText] = useState("");
  const [earliestExpirationDiscount, setEarliestExpirationDiscount] =
    useState(null);
  // const [weeksAwayFromNextEvent, setWeeksAwayFromNextEvent] = useState(0);

  const handleDismissBanner = () => {
    setShowBanner(false);
  };

  useEffect(() => {
    const comparisonDate = new Date();

    const generalDiscounts = dbDiscounts.filter((discount) => {
      const hasValidExpiration =
        discount.expirationDate &&
        new Date(discount.expirationDate) > comparisonDate;

      const isGeneralUse = !discount.eventId;
      const isVisible = discount.isShowable !== false;

      return isGeneralUse && isVisible && hasValidExpiration;
    });
    console.log("General Discounts:", generalDiscounts);

    const nextExpiringDiscount = generalDiscounts.reduce(
      (earliestDiscount, discount) => {
        const expirationDate = new Date(discount.expirationDate);
        if (
          !earliestDiscount ||
          expirationDate < new Date(earliestDiscount.expirationDate)
        ) {
          return discount;
        }
        return earliestDiscount;
      },
      null
    );

    if (!nextExpiringDiscount) {
      setEarliestExpirationDiscount(null);
      setShowBanner(false);
    } else {
      setEarliestExpirationDiscount(nextExpiringDiscount);
      setBannerText(nextExpiringDiscount.description);
      setShowBanner(true);
    }
  }, []);

  if (showBanner && earliestExpirationDiscount) {
    return (
      <div className="flex absolute z-30 w-full items-center gap-x-6  bg-ttOrange-500 px-6 py-1 sm:px-1 sm:before:flex-1">
        <p className="text-sm leading-6 text-white">
          {earliestExpirationDiscount.description}
          {/* <svg
            viewBox="0 0 2 2"
            className="mx-2 inline h-0.5 w-0.5 fill-current"
            aria-hidden="true"
          >
            <circle cx={1} cy={1} r={1} />
          </svg> */}
          <span className="ml-2">
            <Link to="/reservations">
              <strong className="font-semibold">
                Use code {earliestExpirationDiscount.code} at checkout!
              </strong>
            </Link>
          </span>
        </p>
        <div className="flex flex-1 justify-end">
          <button
            type="button"
            onClick={() => setShowBanner(false)}
            className="p-2 focus:outline-none"
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon className="h-5 w-5 text-white" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
